import { whitelineApi } from './index';

export type AddressSuggestionScope = 'legal' | 'warehouse';

export interface AddressSuggestionItem {
  city: string;
  complete: boolean;
  fias_id?: string;
  fiasId?: string;
  message?: string | null;
  unrestricted_value?: string;
  unrestrictedValue?: string;
  value: string;
}

export interface GetAddressSuggestionsRequest {
  count?: number;
  query: string;
  scope: AddressSuggestionScope;
}

export type GetAddressSuggestionsResponse = AddressSuggestionItem[];

export const getAddressSuggestions = async (
  payload: GetAddressSuggestionsRequest,
  signal?: AbortSignal
): Promise<GetAddressSuggestionsResponse> => {
  const response = await whitelineApi.post<GetAddressSuggestionsResponse>(
    '/api/suggestions/address',
    {
      count: payload.count ?? 10,
      query: payload.query,
      scope: payload.scope
    },
    {
      signal
    }
  );

  return response.data;
};

export interface GetAddressEnSuggestionRequest {
  value: string;
}

export interface GetAddressEnSuggestionResponse {
  addressEn: string;
}

export const getAddressEnSuggestion = async (
  payload: GetAddressEnSuggestionRequest,
  signal?: AbortSignal
): Promise<GetAddressEnSuggestionResponse> => {
  const response = await whitelineApi.post<GetAddressEnSuggestionResponse>(
    '/api/suggestions/address/en',
    {
      value: payload.value
    },
    {
      signal
    }
  );

  return response.data;
};